"use client";
import React, { useState,useRef,useEffect } from "react";
import styles from "./FAQPage.module.css"
import dynamic from 'next/dynamic';
const Header = dynamic(() => import('@/Component/Header'), { ssr: false });
const TitleText = dynamic(() => import('@/Component/TitleText'), { ssr: false });
const Footer = dynamic(() => import('@/Component/Footer'), { ssr: false });
import { useTranslation } from "react-i18next";
import down_btn from "@/assets/Icon/Down_Icon.png";
import Image from "next/image"
const FAQ = ({index,question_key, answer_key}) => {
    const { t } = useTranslation();
    const [isOpen,setIsOpen] = useState(false);

    const contentRef = useRef(null);
        const [height, setHeight] = useState(0);
        useEffect(() => {
            if (contentRef.current) {
                setHeight(contentRef.current.scrollHeight); // 실제 높이 구함
            }
        }, [isOpen]);
    return (
        <div key={index} className={`${styles.accordion__list} ${isOpen ? styles.open : ""}`}>
            <div className={styles.accordion__list__question} onClick={() => setIsOpen(!isOpen)}>
                <div className={styles.question}>
                    <span>
                        {`${index + 1}.`}
                    </span>
                    <span>
                        {t(question_key)}
                    </span>
                </div>
                <div className={`${styles.lang__down__btn} ${isOpen ? styles.open :""}`} >
                    <Image src={down_btn} className={styles.lang__down__btn__image} alt="open"/>
                </div>
            </div>
            <div className={`${styles.accordion__list__answer} ${isOpen ? styles.open : ""}`} ref={contentRef}>
                <span  className={styles.accordion__list__answer__text} style={isOpen ? { maxHeight: `${height}px` } : {}}>
                    {t(answer_key)}
                </span>
            </div>
        </div>
    );
}

const FAQPage = ({ FAQListData, titleTextKey,headerTextKey }) => {
    const { t } = useTranslation();
    return (
        <div className={styles.faq}>
            <Header></Header>
            <div className={styles.faq__container}>

                <TitleText titleTextInfo={{ textKey: headerTextKey }}></TitleText>
                <div className={styles.faq__content}>
                    <div className={styles.faq__content__title}>
                        <span >
                            {t(`${titleTextKey}.FAQ.Title`)}
                        </span>
                    </div>
                    <div className={styles.faq__list}>
                        {FAQListData.map((item, index) => (
                            <div key={index} className={styles.accordion__list__container}>
                                {item.titleTextKey &&
                                    <span className={styles.accordion__list__title}>
                                        {t(item.titleTextKey)}
                                    </span>}
                                {item.FAQ_List.map((item, index) => (
                                    <FAQ key={index} index={index} answer_key={item.answer_key} question_key={item.question_key}></FAQ>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer></Footer>
        </div>
    );
}

export default FAQPage;